import {Dispatch, memo, SetStateAction} from 'react';
import {useAppSelector} from "../../../store/hooks/redux";

import {ReactComponent as LangSVG} from '../../../utils/images/icons/lang.svg'
import {getLanguage} from "../../../store/reducers/language/getLanguege/getLanguage";
import Select from "@mui/material/Select";
import {InputAdornment, MenuItem} from "@mui/material";
import {
    buildLanguagePath,
    normalizeLanguage,
    readLanguageFromPath,
    SUPPORTED_LANGUAGES,
} from "../../../config/languages";

type SwitchLangProps = {
    /** Accepted but unused since the custom markup was replaced by MUI Select. */
    className?: string
    setIsLanguageChanging?: Dispatch<SetStateAction<boolean>>;
}

const LANGUAGE_LABELS: Record<string, string> = {
    en: 'EN',
    pl: 'PL',
    ru: 'RU',
}

export const SwitchLang = memo(({setIsLanguageChanging}: SwitchLangProps) => {
    const language = useAppSelector(getLanguage)

    /**
     * A full load onto the new prefix, not an in-place switch: the router basename
     * is fixed for the life of the document, and reloading keeps the language,
     * the URL and every cached translation from drifting apart.
     */
    const changeLanguageHandler = (e: any) => {
        setIsLanguageChanging?.(false);
        const {pathname} = readLanguageFromPath(window.location.pathname);
        const {search, hash} = window.location;
        window.location.assign(
            `${buildLanguagePath(normalizeLanguage(e.target.value), pathname)}${search}${hash}`
        );
    }

    const handleSelectOpen = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        if (setIsLanguageChanging) {
            setIsLanguageChanging(true);
        }
    };

    return (
        <Select
            onOpen={handleSelectOpen}
            MenuProps={{disableScrollLock: true}}
            sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                },
                '& .MuiSelect-icon': {
                    color: 'white',
                }
            }}
            startAdornment={
                <InputAdornment position={'start'}>
                    <LangSVG />
                </InputAdornment>
            }
            value={language}
            onChange={changeLanguageHandler}
            style={{ color: "white", width: "max-content", paddingLeft: "0px", marginLeft: "10px" }}
        >
            {SUPPORTED_LANGUAGES.map(code => (
                <MenuItem key={code} value={code}>{LANGUAGE_LABELS[code]}</MenuItem>
            ))}
        </Select>
    );
});
